import { toRaw } from 'vue';

/**
 * Copy the page's breadcrumbs with the last one (the current page) renamed.
 *
 * Returns plain objects: Inertia writes page props into history.state, which
 * can't hold Vue proxies, so writing reactive items back into page.props
 * fails later with a DataCloneError (MY10X-2C4).
 *
 * @param {Array<Object>} breadcrumbs
 * @param {string} title
 * @returns {Array<Object>}
 */
export function withCurrentPageTitle(breadcrumbs, title) {
    const plainBreadcrumbs = (breadcrumbs || []).map((crumb) => ({ ...toRaw(crumb) }));

    if (plainBreadcrumbs.length > 0) {
        plainBreadcrumbs[plainBreadcrumbs.length - 1].title = title;
    }

    return plainBreadcrumbs;
}
